import React from 'react';
import { Ticket, Calendar, Percent, Banknote, Clock, ShieldCheck, Info } from "lucide-react";

export default function PromoDetailsView({ tr }) {
  if (!tr) return null;

  const now = new Date();
  const start = new Date(tr.startDate);
  const end = new Date(tr.endDate);

  const isPlanifiee = now < start;
  const isExpiree = now > end;
  const isActive = now >= start && now <= end;

  return (
    <div className="tripCard modern pageMode">
      <div className="tripTop">
        <div className="headerWithIcon" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
          <div className="headerIcon" style={{ background: 'rgba(3, 105, 161, 0.1)', padding: '10px', borderRadius: '12px' }}>
            <Ticket size={32} color="#0369a1" />
          </div>
          <div>
            <div className="tripId">Code Promo : <span style={{ color: '#0369a1' }}>{tr.code}</span></div>
            <div className="tripDate">Créé le : {new Date(tr.created_at).toLocaleDateString("fr-FR")}</div>
          </div>
        </div>
        <div className="tripRight">
          <span className={`typeBadge ${isActive ? "green" : isPlanifiee ? "yellow" : "red"}`}>
            {isActive ? "Active" : isPlanifiee ? "Planifiée" : "Expirée"}
          </span>
        </div>
      </div>

      <div className="tripGrid">
        <div className="leftColumn">
          <div className="tripBlock">
            <div className="blockTitle">Configuration de la remise</div>
            <div className="contentBox" style={{ display: 'flex', alignItems: 'center', gap: '20px', padding: '1.5rem', background: '#f8fafc', borderRadius: '12px', border: '1px solid #edf2f7' }}>
              {tr.percentage ? (
                <>
                  <div style={{ background: '#e0f2fe', padding: '12px', borderRadius: '24%' }}>
                    <Percent size={32} color="#0369a1" />
                  </div>
                  <div>
                    <div style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b' }}>{tr.percentage} %</div>
                    <div style={{ color: '#64748b' }}>Réduction appliquée sur le prix total</div>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ background: '#dcfce7', padding: '12px', borderRadius: '24%' }}>
                    <Banknote size={32} color="#16a34a" />
                  </div>
                  <div>
                    <div style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b' }}>{tr.amount} CFA</div>
                    <div style={{ color: '#64748b' }}>Remise fixe déduite du montant</div>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Bloc Période */}
          <div className="tripBlock">
            <div className="blockTitle">Période de validité</div>
            <div className="infoGrid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
               <div style={{ background: '#fff', padding: '15px', borderRadius: '10px', border: '1px solid #f1f5f9' }}>
                  <InfoItem icon={<Calendar size={18} />} label="Date de début" value={new Date(tr.startDate).toLocaleString("fr-FR")} />
               </div>
               <div style={{ background: '#fff', padding: '15px', borderRadius: '10px', border: '1px solid #f1f5f9' }}>
                  <InfoItem icon={<Clock size={18} />} label="Date de fin" value={new Date(tr.endDate).toLocaleString("fr-FR")} />
               </div>
            </div>
          </div>
        </div>

        <div className="rightColumn">
          <div className="tripBlock">
            <div className="blockTitle">Informations système</div>
            <div className="infoList" style={{ background: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #f1f5f9' }}>
              <InfoItem 
                icon={<ShieldCheck size={18} />} 
                label="Identifiant Unique" 
                value={tr.id} 
              />
              <div style={{ margin: '15px 0', borderTop: '1px solid #f1f5f9' }}></div>
              <InfoItem 
                icon={<Info size={18} />} 
                label="Statut actuel" 
                value={isActive ? "En cours d'utilisation" : isPlanifiee ? "En attente d'activation" : "Archivée / Expirée"} 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function InfoItem({ icon, label, value }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <div style={{ color: '#94a3b8' }}>{icon}</div>
      <div>
        <div style={{ fontSize: '0.7rem', color: '#94a3b8', textTransform: 'uppercase', fontWeight: '600' }}>{label}</div>
        <div style={{ fontWeight: '600', color: '#1e293b', fontSize: '0.95rem' }}>{value || "-"}</div>
      </div>
    </div>
  );
}